import React from 'react';
import { GlobeIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Offer() {
  return <section id="offer" className="w-full bg-ink-deep px-4 py-14" data-id="element-179" data-mp="306ho3n9sdxb2">
      <div className="mx-auto w-full max-w-xl" data-id="element-180" data-mp="356vm0chobqvd">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-181" data-mp="357nh7m7czml4">
          Total Value Stack
        </h2>

        <div className="mt-7 rounded-3xl border border-white/10 bg-white/[0.05] p-5" data-id="element-182" data-mp="3f40cupmgsaii">
          <div className="flex items-center justify-between gap-3 border-b border-white/10 pb-3" data-id="element-183" data-mp="3jvidfckks92y">
            <span className="text-[14px] text-white/80" data-id="element-184" data-mp="3nwlqjrb8nr0h">6-Volume Clinical System</span>
            <span className="font-display text-lg font-bold text-white" data-id="element-185" data-mp="3svyekfduj44n">$197</span>
          </div>
          <div className="flex items-center justify-between gap-3 border-b border-white/10 py-3" data-id="element-186" data-mp="1pn7a1i8t74v">
            <span className="text-[14px] text-white/80" data-id="element-187" data-mp="1klgnmqidson1">5 Exclusive Bonuses</span>
            <span className="font-display text-lg font-bold text-white" data-id="element-188" data-mp="1kjdmbabs3930">$197</span>
          </div>
          <div className="flex items-center justify-between gap-3 pt-3" data-id="element-189" data-mp="1fohuaa6jklpw">
            <span className="text-[13px] font-bold uppercase tracking-wide text-gold-light" data-id="element-190" data-mp="1blbpz82zp4m2">
              Total Value
            </span>
            <span className="font-display text-xl font-bold text-white line-through opacity-70" data-id="element-191" data-mp="23byc2iw6ky2l">
              $394 USD
            </span>
          </div>
        </div>

        <div className="mt-6 rounded-3xl border-2 border-gold bg-white p-6 text-center" data-id="element-192" data-mp="1zaw7rnnepvtr">
          <p className="flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-193" data-mp="1ui35r7jbp1ld">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-194" data-mp="1piqjanwd5wjb" />
            Today only: get everything for just
          </p>
          <p className="mt-2 font-display text-6xl font-extrabold leading-none text-ink sm:text-7xl" data-id="element-195" data-mp="2i9i8v2ixbmxo">
            $27
            <span className="ml-1 align-super text-lg font-bold text-ink-soft" data-id="element-196" data-mp="3157guorv7mri">USD</span>
          </p>
          <p className="mt-3 text-[13px] font-semibold text-ink-soft" data-id="element-197" data-mp="363in6piybf4z">
            💳 One-time payment · No subscription
          </p>
          <p className="mt-1 flex items-center justify-center gap-1.5 text-[13px] font-semibold text-emerald-700" data-id="element-198" data-mp="2scx5v595bd97">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-199" data-mp="2wcebbyokoaed" />
            Automatic currency conversion — pay in your local currency
          </p>

          <div className="mt-6" data-id="element-200" data-mp="2nf3w628mw146">
            <CTAButton label="GET INSTANT ACCESS NOW" note="Download immediately · Lifetime access · 7-day guarantee" data-id="element-201" data-mp="2nbzm4o8hmb5l" />
          </div>

          <Countdown data-id="element-202" data-mp="2dgo704t631xb" />
          <ScarcityBar data-id="element-203" data-mp="2dhz8tz31xzls" />
        </div>
      </div>
    </section>;
}